module.exports = __webpack_public_path__ + "img/PatioFurnitureSets.61e63c55.png";